// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dQfB","headerLogo":"styles_headerLogo__51P45","navbar":"styles_navbar__2CXr6"};